<mat-card [formGroup]="formGroup" class="app-client-form-card">
  <div class="flex items-center justify-between mt1 mb2">
    <h4 class="my0 bold">
      {{
        'CLIENT.TITLE'
          | translate
            : {
                id: id
              }
      }}
    </h4>

    <div class="flex items-center" [formGroup]="formGroup.get('signingRequest')">
      <div class="flex items-center font-normal">
        <div class="mr1">{{ 'CLIENT_FORM_CARD.REQUEST_SIGNATURE.CHANNEL.TITLE' | translate }}</div>
        <lib-hint
          [text]="'CLIENT_FORM_CARD.REQUEST_SIGNATURE.CHANNEL.SUBTITLE' | translate"
          class="mr2"
        ></lib-hint>

        <app-signing-request-channel-select
          formControlName="channel"
        ></app-signing-request-channel-select>
      </div>

      <lib-button *ngIf="displayClose" weight="tertiary" icon="delete" (click)="clickClose.emit()"
        >{{ 'COMMON.REMOVE' | translate }}
      </lib-button>
    </div>
  </div>

  <div class="flex flex-wrap mb2 mxn2">
    <div class="mb2 col-6 border-box px2">
      <mat-form-field class="full-width">
        <mat-label>{{ 'CLIENT.NAME' | translate }}</mat-label>
        <input matInput formControlName="forename" />
        <mat-error
          ><app-input-errors [control]="formGroup.get('forename')"></app-input-errors
        ></mat-error>
      </mat-form-field>
    </div>

    <div class="mb2 col-6 border-box px2">
      <mat-form-field class="full-width">
        <mat-label>{{ 'CLIENT.SURNAME' | translate }}</mat-label>
        <input matInput formControlName="surname" />
        <mat-error
          ><app-input-errors [control]="formGroup.get('surname')"></app-input-errors
        ></mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="'birthYear' | isClientFieldVisible" class="mb2 col-6 border-box px2">
      <mat-form-field class="full-width">
        <mat-label>{{ 'CLIENT.BIRTHYEAR' | translate }}</mat-label>
        <input matInput formControlName="birthYear" />
        <mat-error
          ><app-input-errors [control]="formGroup.get('birthYear')"></app-input-errors
        ></mat-error>
      </mat-form-field>
    </div>

    <div class="mb2 col-6 border-box px2">
      <mat-form-field class="full-width">
        <mat-label>{{ 'CLIENT.PERSONAL_ID' | translate }}</mat-label>
        <input matInput formControlName="personalId" />
        <mat-error
          ><app-input-errors [control]="formGroup.get('personalId')"></app-input-errors
        ></mat-error>
      </mat-form-field>
    </div>

    <div class="mb2 col-6 border-box px2">
      <mat-form-field class="full-width">
        <ngx-mat-intl-tel-input
          class="app-phone-input"
          [preferredCountries]="[envConfig.data.preferredTelCountry]"
          [enablePlaceholder]="true"
          [enableSearch]="true"
          [placeholder]="'CLIENT.PHONE_CONTACT' | translate"
          name="phone"
          formControlName="phone"
        ></ngx-mat-intl-tel-input>
        <mat-error
          ><app-input-errors
            [control]="formGroup.get('phone')"
            [additionalFormErrorMsgs]="additionalFormErrorMsgs"
          ></app-input-errors
        ></mat-error>
      </mat-form-field>
    </div>

    <div class="mb2 col-6 border-box px2">
      <mat-form-field class="full-width">
        <mat-label>{{ 'CLIENT.EMAIL' | translate }}</mat-label>
        <input matInput formControlName="email" />
        <mat-error
          ><app-input-errors
            [control]="formGroup.get('email')"
            [additionalFormErrorMsgs]="additionalFormErrorMsgs"
          ></app-input-errors
        ></mat-error>
      </mat-form-field>
    </div>
  </div>

  <div
    *ngIf="
      isChannelSelected &&
      ((isEmailChannelSelected && ('signingRequestSubject' | isClientFieldVisible)) ||
        ('signingRequestBody' | isClientFieldVisible))
    "
    class="flex flex-column"
    [formGroup]="signingRequestFormGroup"
  >
    <mat-form-field
      *ngIf="isEmailChannelSelected && ('signingRequestSubject' | isClientFieldVisible)"
      class="mb2"
    >
      <mat-label>{{ 'CLIENT_FORM_CARD.REQUEST_SIGNATURE.SUBJECT.TITLE' | translate }}</mat-label>
      <input matInput formControlName="subject" />
      <mat-error
        ><app-input-errors [control]="signingRequestFormGroup.get('subject')"></app-input-errors
      ></mat-error>
    </mat-form-field>

    <mat-form-field
      *ngIf="'signingRequestBody' | isClientFieldVisible"
      class="mb2"
      appearance="outline"
    >
      <mat-label>{{ 'CLIENT_FORM_CARD.REQUEST_SIGNATURE.BODY.TITLE' | translate }}</mat-label>
      <textarea matInput formControlName="body" [rows]="4"></textarea>

      <mat-hint>
        <div
          class="app-request-signature-body-hint"
          [innerHTML]="'CLIENT_FORM_CARD.REQUEST_SIGNATURE.BODY.HINT' | translate"
        ></div>
      </mat-hint>

      <mat-error
        ><app-input-errors [control]="signingRequestFormGroup.get('body')"></app-input-errors
      ></mat-error>
    </mat-form-field>
  </div>
</mat-card>
